import React from 'react';
import { connect } from 'react-redux';
import Config from '../../../../../Config';
import Property from '@episerver/spa-core/Components/Property';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
// import CollaborationApproval from '../../Partials/CollaborationApproval/CollaborationApproval';

const MovingFooter = (props) => {

    return (
        <>

            <div className={`buttonContainer ${props.page === 'summaryPage' ? 'sticky' : ''}`}>
                <div className='footer-messege'>{props.footerMessage}</div>

                <BtnSubmit
                    text={props.btnText}
                    onclick={props.onBtnClick}
                    formid='moving'
                />
                {props.isDisplayWhatsApp && <span onClick={() => props.callBackService()} className='bottom-title'>תחזרו אליי בטלפון</span>}
                {/* {
                    props.page === 'summaryPage' && props.isDisplayCollaborationApproval &&
                    <CollaborationApproval isCollaborationApproval={props.isCollaborationApproval} />
                } */}

            </div>
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        page: state.movingBlock.movingApartmentData.page,
        isCollaborationApproval: state.movingBlock.movingApartmentData.isCollaborationApproval,
        //isDisplayCollaborationApproval: state.movingBlock.movingApartmentData.isDisplayCollaborationApproval,
        footerMessage: state.movingBlock.movingApartmentData.footerMessage
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MovingFooter);

